export default __webpack_public_path__ + "static/media/roller6.ecfc1193.gif";